// import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    admindashboard() {
        return API.get('admindashboard')
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
};
